;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();export const BLACK_COLOR = "Black"
export const YELLOW_COLOR = "Yellow"
export const ACCENT_COLOR = "#E6FF63"

export const PRIMARY_YELLOW_BUTTON_TYPE = "PRIMARY_YELLOW_BUTTON_TYPE"
export const PRIMARY_BLACK_BUTTON_TYPE = "PRIMARY_BLACK_BUTTON_TYPE"
export const SECONDARY_BUTTON_TYPE = "SECONDARY_BUTTON_TYPE"

export const GROUP_TYPE_WORKSHOP = "workshop"
export const GROUP_TYPE_THERAPY_GROUP = "therapy group"
export const GROUP_TYPE_SUPPORT_GROUP = "support group"
export const GROUP_TYPE_RETREATS = "retreats"
export const GROUP_TYPE_CLINICAL_PEER_GROUP = "clinical peer group"

export const POST_HERE_SEARCH_ICON = "POST_HERE_SEARCH_ICON"
export const POST_HERE_REFERRAL_ICON = "POST_HERE_REFERRAL_ICON"
export const POST_HERE_SEATS_ICON = "POST_HERE_SECURE_SEATS_ICON"
export const POST_HERE_PAYMENTS_ICON = "POST_HERE_PAYMENTS_ICON"
export const POST_HERE_MARKETING_ICON = "POST_HERE_MARKETING_ICON"
export const POST_HERE_REACH_ICON = "POST_HERE_REACH_ICON"

export const CREATED_ZESTLIFE_REASON_STAND_FOR_GROUPS = "STAND_FOR_GROUPS"
export const CREATED_ZESTLIFE_REASON_OPEN_DOORS = "OPEN_DOORS"
export const CREATED_ZESTLIFE_REASON_STRONGER_TOGETHER = "STRONGER_TOGETHER"
